// extracted by mini-css-extract-plugin
export default {"wrapper":"Display_wrapper__HmsvB","bg":"Display_bg__5LtuD"};